// @ts-strict-ignore
export const emulateTabBehaviorInMonaco = ({ editor, inputElement, monaco }) => {
  if (!inputElement) {
    return;
  }
  // Monaco has a bug where commands are only added to the last instance, which
  // is why we need to re-add commands when an editor is focused
  // https://github.com/microsoft/monaco-editor/issues/2947
  editor.onDidFocusEditorText(() => {
    // Reference: https://stackoverflow.com/a/48848078
    // .rename-input is another tab trap we need to avoid here
    const allElements = document.querySelectorAll<HTMLInputElement>(
      "input:not(.rename-input), button, a, area, object, select, textarea, [contenteditable]"
    );
    const currentIndex = [...allElements].findIndex((el) => inputElement.isEqualNode(el));

    editor.addCommand(monaco.KeyCode.Tab, () => {
      const targetIndex = (currentIndex + 1) % allElements.length; // focus next element
      allElements[targetIndex].focus();
    });

    editor.addCommand(monaco.KeyMod.Shift | monaco.KeyCode.Tab, () => {
      const targetIndex = (currentIndex - 1) % allElements.length; // focus previous element
      allElements[targetIndex].focus();
    });
  });
};
